import vue from "vue";
import NavBar from "@/components/NavBar.vue";

vue.component(NavBar.name, NavBar);
